import { useState, useEffect } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export default function useTotalOrgCount() {
    const [count, setCount] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const api = useAuthenticatedApi();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(
                    '/photo-engineers/total-org-count',
                );
                setCount(response.data);
            } catch (error) {
                console.error('Error fetching total org count:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [api]);

    return { count, isLoading };
}
